import React, { Suspense, lazy } from 'react';
import { Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import Home from 'Pages/Home';
import configureStore from 'Store/store';
import Item from 'Pages/Item';
import Checkout from 'Pages/checkout/Checkout';
import AddEditItem from 'Pages/AddEditItem';
import Register from 'Pages/Register';
import Login from 'Pages/Login';
import FoundSomething from 'Pages/FoundSomething';
import Signup from 'Pages/Signup';
import ItemReview from 'Pages/ItemReview';
import Dashboard from 'Pages/Dashboard';
import Contact from 'Pages/Contact';
import PrivacyPolicy from 'Pages/PrivacyPolicy';
import Pricing from 'Pages/ProductRegistration/Pricing';
import RegDashboard from 'Pages/ProductRegistration/Dashboard';
import AddEditCode from 'Pages/ProductRegistration/AddEditCode';
import RegisterProduct from 'Pages/ProductRegistration/RegisterProduct';
import RegCodeDetails from 'Pages/ProductRegistration/CodeDetails';
import Customers from 'Pages/ProductRegistration/Customers';
import Account from 'Pages/ProductRegistration/Account';
import CreateToken from 'Pages/Tokens/Create';
import Info from 'Pages/Tokens/Info';
import Info2 from 'Pages/Tokens/Info2';
import WarholInfo from 'Pages/Tokens/Warhol/Info';
import WarholCertificate from 'Pages/Tokens/Warhol/Certificate';
import TOS from 'Pages/TOS';
import ScrollToTop from 'Components/ScrollToTop';
import Auth from './Auth';
import history from './history';
//import ReactGA from 'react-ga';
//import config from './Config/firebase';
import { Switch } from 'react-router';

//import ShopifyAccount from 'ShopifyApp/Account';

//Lazy loaded
const ShopifyOrders = lazy(() => import('ShopifyApp/Orders'));
const ShopifyOrder = lazy(() => import('ShopifyApp/Order'));
const ShopifySettings = lazy(() => import('ShopifyApp/Settings'));
const ShopifyAccount = lazy(() => import('ShopifyApp/Account'));
const ShopifyInstallComplete = lazy(() => import('ShopifyApp/InstallComplete'));

//ReactGA.initialize(config.ga);
//ReactGA.pageview(window.location.pathname + window.location.search);

const { store } = configureStore();

// Initialize google analytics page view tracking
// history.listen((location) => {
//   ReactGA.set({ page: location.pathname }); // Update the user's current page
//   ReactGA.pageview(location.pathname); // Record a pageview for the given page
// });

const Loading = <div></div>;

const Routes = () => (
  <Provider store={store}>
    <Auth>
      <Router history={history}>
        <ScrollToTop>
          <Suspense fallback={Loading}>
            <Switch>
              <Route path="/i/:id" exact component={Item} />
              <Route path="/checkout" exact component={Checkout} />
              <Route path="/add-item" exact component={AddEditItem} />
              <Route path="/edit-item" exact component={AddEditItem} />
              <Route path="/item-review" exact component={ItemReview} />
              <Route path="/login" exact component={Login} />
              <Route path="/signup" exact component={Signup} />
              <Route path="/found-something" exact component={FoundSomething} />
              <Route path="/register/" exact component={Register} />
              <Route path="/register/:code" exact component={Register} />
              <Route path="/dashboard" exact component={Dashboard} />
              <Route path="/contact" exact component={Contact} />
              <Route path="/privacy-policy" exact component={PrivacyPolicy} />
              <Route path="/pricing" exact component={Pricing} />
              <Route path="/TOS" exact component={TOS} />

              <Route path="/reg/:id" exact component={RegisterProduct} />
              <Route path="/product-registration/pricing" exact component={Pricing} />
              <Route path="/product-registration/customers/:id?" component={Customers} />
              <Route path="/product-registration/account" exact component={Account} />
              <Route path="/product-registration/dashboard" exact component={RegDashboard} />
              <Route path="/product-registration/add-code" exact component={AddEditCode} />
              <Route path="/product-registration/edit-code" exact component={AddEditCode} />
              <Route path="/product-registration/code-details/:id" exact component={RegCodeDetails} />

              <Route path="/token/create" exact component={CreateToken} />
              <Route path="/token/:contractAddress/:tokenId" exact component={Info} />
              <Route path="/token2/:contractAddress/:tokenId" exact component={Info2} />
              <Route path="/nft/andy-warhol-deborah-harry-original-nft" exact component={WarholInfo} />
              <Route path="/certificate/andy-warhol-deborah-harry-original-nft" exact component={WarholCertificate} />

              <Route path="/shopify/order" exact component={ShopifyOrder} />
              <Route path="/shopify/orders" exact component={ShopifyOrders} />
              <Route path="/shopify/settings" exact component={ShopifySettings} />
              <Route path="/shopify/account" exact component={ShopifyAccount} />
              <Route path="/shopify/ui" exact component={ShopifyInstallComplete} />

              {/* / needs to be last without 'exact' to catch hash tags */}
              <Route path="/" exact component={Home} />
            </Switch>
          </Suspense>
        </ScrollToTop>
      </Router>
    </Auth>
  </Provider>
);

export default Routes;
